import { render, staticRenderFns } from "./NsHeaderLegalLinks.vue?vue&type=template&id=08906304&scoped=true&"
import script from "./NsHeaderLegalLinks.vue?vue&type=script&lang=js&"
export * from "./NsHeaderLegalLinks.vue?vue&type=script&lang=js&"
import style0 from "./NsHeaderLegalLinks.vue?vue&type=style&index=0&id=08906304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08906304",
  null
  
)

export default component.exports